// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Ee3Pm","title":"style_title__lzta2"};